import getSurfaceStore from '../store/store';
import setIsSurfaceReloadPending from '../mutators/isSurfaceReloadPendingMutators';
import { reloadCalendarSurface } from '../actions/publicActions';

/**
 * Triggers action to reload surface if surface reload pending flag is true
 */
export default function reloadCalendarSurfaceIfRequired() {
    if (getSurfaceStore().isSurfaceReloadPending) {
        setIsSurfaceReloadPending(false);
        reloadCalendarSurface();
    }
}
